import React, { useState } from 'react';
import { Calendar, CheckCircle, User, Clock, Sparkles, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../components/MobileLayout';
import { PianificaPuliziaWizard } from '../components/PianificaPuliziaWizard';
import { Tabs } from '../components/ui/Tabs';
export function PuliziePage() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'gestione' | 'opportunita'>('gestione');
  // Mock data for upcoming cleanings
  const prossimePulizie = [{
    id: '1',
    property: 'Villa Sunset',
    date: 'Mer 17 Gen',
    time: '11:00 - 15:00',
    status: 'in_corso',
    cleaner: 'Francesca N.',
    cleanerImg: 'https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png',
    isShareable: true
  }, {
    id: '2',
    property: 'Villa Sunset',
    date: 'Ven 19 Gen',
    time: '12:00 - 14:30',
    status: 'pianificata',
    cleaner: 'Roberto F.',
    cleanerImg: '',
    isShareable: false
  }];
  // Mock data for completed cleanings
  const pulizieCompletate = [{
    id: '3',
    property: 'Villa Sunset',
    date: 'Lun 15 Gen',
    duration: '3h 30min',
    cleaner: 'Francesca N.',
    aiScore: 98,
    isShareable: true
  }, {
    id: '4',
    property: 'Villa Sunset',
    date: 'Ven 12 Gen',
    duration: '4h',
    cleaner: 'Roberto F.',
    aiScore: 100,
    isShareable: false
  }];
  const shareableProssime = prossimePulizie.filter(p => p.isShareable);
  const shareableCompletate = pulizieCompletate.filter(p => p.isShareable);
  const totalShareable = shareableProssime.length + shareableCompletate.length;
  return <MobileLayout data-id="element-3547">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-3548">
        <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-3549">
          Pulizie
        </h1>
      </div>

      {/* Tabs */}
      <Tabs className="mb-6" value={activeTab} onValueChange={id => setActiveTab(id as 'gestione' | 'opportunita')} items={[{
      id: 'gestione',
      label: 'Gestione'
    }, {
      id: 'opportunita',
      label: 'Opportunità',
      badge: totalShareable > 0 ? <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold bg-coral text-white rounded-full" data-id="element-3551">
                  {totalShareable}
                </span> : undefined
    }]} data-id="element-3550" />

      {/* TAB: Gestione */}
      {activeTab === 'gestione' && <>
          {/* In corso / Prossime */}
          <div className="mb-8" data-id="element-3552">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3553">
              In corso e prossime
            </div>

            <div className="space-y-3" data-id="element-3554">
              {prossimePulizie.map(pulizia => {
            const isInProgress = pulizia.status === 'in_corso';
            return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3555">
                    <div className="flex justify-between items-start mb-3" data-id="element-3556">
                      <div data-id="element-3557">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3558">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3559">
                          <span className="flex items-center gap-1" data-id="element-3560">
                            <Calendar size={12} data-id="element-3561" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3562">
                            <Clock size={12} data-id="element-3563" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3564">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3565">
                      <div className="flex items-center gap-2" data-id="element-3566">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3567" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3568">
                            <User size={14} className="text-muted-foreground" data-id="element-3569" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3570">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3571" />
                    </div>
                  </Link>;
          })}
            </div>
          </div>

          {/* Completate */}
          <div className="mb-6" data-id="element-3572">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3573">
              Completate di recente
            </div>

            <div className="space-y-3" data-id="element-3574">
              {pulizieCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3575">
                  <div data-id="element-3576">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3577">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3578">
                      <span className="flex items-center gap-1" data-id="element-3579">
                        <Calendar size={12} data-id="element-3580" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3581">
                        <Clock size={12} data-id="element-3582" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3583">
                    <div className="flex flex-col items-end" data-id="element-3584">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3585">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3586">
                        <CheckCircle size={12} data-id="element-3587" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3588" />
                  </div>
                </Link>)}
            </div>
          </div>
        </>}

      {/* TAB: Opportunità */}
      {activeTab === 'opportunita' && <div className="mb-8" data-id="element-3589">
          <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3 flex items-center gap-1.5" data-id="element-3590">
            <Sparkles size={12} className="text-coral" data-id="element-3591" />
            Pulizie condivisibili
          </div>

          {totalShareable === 0 ? <div className="bg-white border border-border rounded-xl p-8 text-center" data-id="element-3592">
              <p className="text-sm text-muted-foreground" data-id="element-3593">
                Nessuna pulizia condivisibile al momento.
              </p>
            </div> : <div className="space-y-3" data-id="element-3594">
              {shareableProssime.map(pulizia => {
          const isInProgress = pulizia.status === 'in_corso';
          return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3595">
                    <div className="flex justify-between items-start mb-3" data-id="element-3596">
                      <div data-id="element-3597">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3598">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3599">
                          <span className="flex items-center gap-1" data-id="element-3600">
                            <Calendar size={12} data-id="element-3601" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3602">
                            <Clock size={12} data-id="element-3603" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3604">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3605">
                      <div className="flex items-center gap-2" data-id="element-3606">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3607" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3608">
                            <User size={14} className="text-muted-foreground" data-id="element-3609" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3610">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3611" />
                    </div>
                  </Link>;
        })}

              {shareableCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3612">
                  <div data-id="element-3613">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3614">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3615">
                      <span className="flex items-center gap-1" data-id="element-3616">
                        <Calendar size={12} data-id="element-3617" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3618">
                        <Clock size={12} data-id="element-3619" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3620">
                    <div className="flex flex-col items-end" data-id="element-3621">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3622">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3623">
                        <CheckCircle size={12} data-id="element-3624" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3625" />
                  </div>
                </Link>)}
            </div>}
        </div>}

      {/* Wizard Modal */}
      <PianificaPuliziaWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-3626" />
    </MobileLayout>;
}